import { isInWebView } from 'utils/isInWebView';

type EventName =
  | 'sign_up'
  | 'upsale_accepted'
  | 'downsale_accepted'
  | 'first_loan_approved';

// Only posts when running inside the React Native WebView; no-op in a regular browser context
export const postMessageToApp = (name: EventName, params = {}) => {
  if (isInWebView()) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        name,
        params,
      }),
    );
  }
};
